import { useEffect } from "react";

const BASE_TITLE = "Boo";

/**
 * Set `document.title` for the current page — `"Page, Boo"`, or the bare base
 * title when passed `null` / `undefined`.
 *
 * No unmount reset: each screen overwrites the title on mount and index.html's
 * `<title>Boo</title>` is the baseline. Resetting to "Boo" on unmount flashed
 * "Boo" on every navigation (the old page's cleanup fires before the new page's
 * effect) and left any untitled screen stuck on "Boo". The trade is that a
 * screen setting no title keeps the previous one — so every real screen sets
 * its own.
 */
export function useDocumentTitle(page?: string | null) {
  useEffect(() => {
    document.title = page ? `${page}, ${BASE_TITLE}` : BASE_TITLE;
  }, [page]);
}
